import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lista_menu: [],

    snackbar: {
      show: false,
      message: "",
      color: "success",
    },
    user:{
    },
    perfil_hir:null,
    perfil_id: 2, //2 é solicitante;
    perfil_label:null,
    perfil_admin_label:false,
    funcionalidades_perfil: [],
  },

  mutations: {
    async showSnackbar(state, payload) {
      const payloadData = await payload;
      state.snackbar.message = payloadData.message;
      state.snackbar.color = payloadData.type;
      state.snackbar.show = true;
    },

    async setListaMenu(state, payload){
      const payloadData = await payload;
      state.lista_menu = await payloadData;
      // console.log('state', state.lista_menu);
      
    }
  },
});
